import type { WebsiteResearch } from '@shared/api-client';

const labels = {
  audience: 'Who it serves',
  value: 'What people come for',
  monetization: 'How the business works',
};

export const WebsiteResearchSummary = ({
  research,
}: {
  research?: WebsiteResearch | null;
}) => {
  if (!research?.sources.length) {
    return null;
  }
  return (
    <details className="text-sm text-ink-muted">
      <summary className="w-fit cursor-pointer py-1 font-medium hover:text-ink">
        Why these goals?
      </summary>
      <div className="mt-4 space-y-4">
        {research.insights.length > 0 && (
          <dl className="space-y-4">
            {research.insights.map((insight) => (
              <div key={insight.kind}>
                <dt className="text-sm font-medium text-ink">
                  {labels[insight.kind]}
                </dt>
                <dd className="mt-1 text-sm leading-relaxed text-ink-muted">
                  {insight.summary}{' '}
                  <a
                    href={insight.sourceUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="text-accent underline underline-offset-4"
                    title={insight.evidence}
                  >
                    Source
                    <span className="sr-only">
                      {' '}
                      for {labels[insight.kind].toLowerCase()}
                    </span>
                  </a>
                </dd>
              </div>
            ))}
          </dl>
        )}
        <details>
          <summary className="cursor-pointer text-sm font-medium text-ink-muted">
            Reviewed pages and evidence
          </summary>
          <ul className="mt-3 space-y-3 text-sm">
            {research.sources.map((source) => (
              <li key={source.url}>
                <a
                  href={source.url}
                  target="_blank"
                  rel="noreferrer"
                  className="break-words text-accent underline underline-offset-4"
                >
                  {source.title || new URL(source.url).hostname}
                </a>
                {research.insights
                  .filter((insight) => insight.sourceUrl === source.url)
                  .map((insight) => (
                    <p
                      key={insight.kind}
                      className="mt-1 break-words leading-relaxed text-ink-muted"
                    >
                      “{insight.evidence}”
                    </p>
                  ))}
              </li>
            ))}
          </ul>
        </details>
      </div>
    </details>
  );
};
